<template>
  <div id="menuNav">
    <div class="menuNav__wrapper">
      <!-- 出纳模块菜单 -->
      <div class="cashierMenu">
        <div class="cashierMenu-cashier cashierMenu-base">
          <div class="cashierMenu-base-wrapper" @click="handleMenuClick('1')" @mouseenter="handleClickBody" v-if = "(cashierList.length || bankList.length) && !disabledMenu">
            <img src="/static/icon/menu/new-cashier.png" alt="" class="cashierMenu-base-img">
            <span class="cashierMenu-base-label" :class="{ menuActive:boldMenu == '1'}">资金管理</span>
          </div>

          <!-- 标识 -->
          <!-- <span class="cashierMenu-cashier-mark">Pro</span> -->
          <!-- 下级菜单 -->
          <div class="c-child-menu">
            <div class="c-child-menu-wrapper" >
              <!-- 出纳系统 -->
              <div class="c-child-menu-wrapper-cashier" v-if = "cashierList.length">
                <div class="c-child-menu-title">
                  <div class="title-pane"></div>
                  <div class="title-text">出纳系统</div>
                </div>
                <ul>
                  <li v-for="(items, index) in cashierList" @click.stop="menud(items,'1')">
                    <span class="c-menuNav-children-title">{{ items.name }}</span>
                  </li>
                </ul>
              </div>
              <!-- 银行流水 -->
              <div class="c-child-menu-wrapper-bank" v-if = "bankList.length">
                <div class="c-child-menu-title">
                  <div class="title-pane"></div>
                  <div class="title-text">银行流水</div>
                </div>
                <ul>
                  <li v-for="(items, index) in bankList" @click.stop="menud(items,'1')">
                    <span class="c-menuNav-children-title">{{ items.name }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="cashierMenu-bank cashierMenu-base" v-if = "physical_report_show">
          <div class="cashierMenu-base-wrapper" @click="handleMenuClick('2')">
            <img src="/static/icon/menu/physical_report.png" alt="" class="cashierMenu-base-img">
            <span class="cashierMenu-base-label" :class="{ menuActive:boldMenu == '2'}">{{physical_report_name}}</span>
          </div>

          <!-- 银行流水下级菜单 -->
          <!-- <template v-if="bankList && bankList.length > 0">
            <ul :class="bankList.length >= 4 ? 'c-child-menu c-double' : 'c-child-menu'">
              <li v-for="(items, index) in bankList" @click.stop="menud(items)">
                <span class="c-menuNav-children-title">{{ items.name }}</span>
              </li>
            </ul>
          </template> -->
        </div>
      </div>
      <ul class="menu-nav" v-if="refash">
        <li v-for="(item, index) in menu" :key="index">
          <div class="menu-nav-item"  @click="menud(item)" :class="getMenuClass(item)">
            <img :src="'/static/icon/menu/' + item.icon + '.png'" class="navImg" v-if='item.active'>
            <img :src="'/static/icon/menu/' + item.function + '.png'" class="navImg" v-else>
            <span class="menuNav-title">{{ item.name }}</span>
            <template v-if="item.children && item.children.length > 0">
              <ul :class="item.children.length >6 ? 'child-menu double' : 'child-menu'">
                <li v-for="(items, index) in item.children" @click.stop="menud(items)">
                  <span class="menuNav-children-title">{{ items.name }}</span>
                </li>
              </ul>
            </template>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      physical_report_name:"",
      disabledMenu: false,
      title: '',
      boldMenu:"", // 选中菜单
      isHaveCashier: false,  // 是否有出纳系统
      bankRow: {}, // 是否有银行流水
      refash: true,
      menu: [],
      cashierList: [],
      bankList: [],
      nowItem: {},
      filterMenu: ["chuna_s", "home_yinghangliushui", "physical_report"],  // 菜单栏上面的特殊菜单
    }
  },
  created() {
    this.getMenuList();
    // 临时根据用户的姓名和id禁用资金管理功能
    // let user = this.$getSessionStorage('user');
    // if(!user) return;
    // const accountId = user.accountId;
    // const userAcc = user.account.userLoginName;
    // if(accountId === "1504006966719021057" || userAcc === "13518135704") {
    //   this.disabledMenu = true;
    // }else {
    //   this.disabledMenu = false;
    // }
  },
  methods: {
    handleClickBody(e) {
      let dom = document.getElementsByClassName("el-popper");
      for (var i = 0; i < dom.length; i++) {
        if (dom[i].style.display !== "none") {
          dom[i].style.display = "none";
        }
      }
    },
    /**
     * @param {String} type 1、出纳系统 2、银行流水
     */
    handleMenuClick(type) {
      if (type == "2") {
        // 体检报告点击
        this.boldMenu = "2";
        this.$router.push('/physical_report');
      }
    },
    // 获取菜单数组
    getMenuList() {
      let menu = this.$getSessionStorage('menu');
      this.cashierList = [];
      this.bankList = [];
      this.physical_report_show = false;
      if (!menu) {
        this.$router.push('/login');
      } else {
        menu.forEach((i, index) => {
          if (i.icon === "chuna_s" && i.children && i.children.length) {
            this.isHaveCashier = true;
            let _cashierList = menu.splice(index, 1)[0].children;
            _cashierList.forEach(row => {
            })
            this.cashierList = _cashierList;
          } else if (i.icon === "home_yinghangliushui" && i.children && i.children.length) {
            let bankList = menu.splice(index, 1)[0].children;
            this.bankList = bankList
          }else if(i.icon === "physical_report"){
            this.physical_report_name = i.name
            this.physical_report_show = true
          }
        })
        this.menu = menu
        this.menu = this.menu.filter(e => {
          return this.filterMenu.indexOf(e.icon) == -1
        })
        this.activeMenu(this.menu, this.$route.path);
      }
    },
    // 获取菜单样式
    getMenuClass(item) {
      let classNames = "";
      if (item.active) {
        classNames = "active";
      }
      return classNames;
    },
    init() {
      //配置型访问
      this.$http({
        method: 'post',
        url: '/sys/menu/getTree',
        data: {},
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        timeout: 2 * 60 * 1000
      }).then(res => {
        this.menu = res.data.data
      })
    },
    // 刷新/重载
    refreshSelectedTag() {
      let NewPage = '_empty' + '?time=' + new Date().getTime() / 500;
      this.$router.push(NewPage);
      this.$router.go(-1);
    },
    menud(item,type) {
      const _ = this;
      const prevent = this.$getSessionStorage('superPreventOperation');
      if (item.href == "/addVoucher" && prevent) {
        this.$store.commit('SUPERPREVENTFUNCTION', true);
        return;
      }
      _.$store.commit('ISCLICKCACHE', true);

      if (item.href && (item.href == this.nowItem.href) && item.href != '/addVoucher') {
        //this.refreshSelectedTag();
      } else {
        this.nowItem.href = item.href;
        if (item.href != '' && item.href != null) {
          this.$router.push(item.href);
          this.boldMenu = type
        }
      }

    },
    activeMenu(list, path, old) {
      const _ = this;
      for (let i = 0; i < list.length; i++) {
        if (list[i].children && list[i].children.length > 0) {
          this.activeMenu(list[i].children, path, list[i]);
        } else {
          if (list[i].href == path) {
            list[i].active = true;
            if (old) {
              old.active = true;
            }
          } else if (list[i].href) {
            list[i].active = false;
            if (old) {
              let j = 0;
              for (let k = 0; k < old.children.length; k++) {
                if (old.children[k].href != path) {
                  j++;
                }
              }
              if (j >= old.children.length) {
                old.active = false;
              }
            }
          }
        }
      }
      // console.log(list);

    },
  },
  mounted() {
    this.$set(this.nowItem, 'href', this.$route.path);
  },
  watch: {
    $route(val, form) {
      this.activeMenu(this.menu, val.path);
      this.nowItem.href = val.path;
      if (form.path == '/queryVoucher' && val.path == '/addVoucher') {
        this.$set(this.nowItem, 'href', val.path);
      }
      this.refash = false;
      this.refash = true;
    }
  }
}
</script>

<style lang="less" scoped>
// @media screen and (min-width:2000px) and (max-width:4096px) {
//   .navImg {
//     width: 20px !important;
//   }

//   .menu-nav {
//     &>li {
//       font-size: 14px !important;
//     }
//   }
// }

#menuNav {
  width: 140px;
  height: 100%;
  position: fixed;
  top: 60px;
  left: 0;
  background-color: #F5F5F5;
  padding-top: 62px;
  z-index: 999;
  .cashierMenu {
    border-radius: 4px;
    .menuActive {
      font-weight: 600;
      color: #269D7B
    }
    &-cashier {
      padding: 0 10px;
      position: relative;
      .cashierMenu-base-wrapper {
        border-bottom: 1px dashed rgba(38, 157, 123, .5);
      }
      &-mark {
        position: absolute;
        top: 0;
        right: 19px;
        background: #F5A623;
        color: #fff;
        font-size: 12px;
        padding: 7px;
        line-height: 12px;
        border-radius: 0 4px 0 4px;
        transform: scale(.9);
      }

      .c-child-menu {
        position: absolute;
        display: none;
        top: 0;
        z-index: 1999;
        box-shadow: 2px 2px 8px 0 #9e9e9e66;
        border-radius: 8px;
        left: 140px;
        padding-left: 0;
        list-style: none;
        background-color: #fff;
        border-left: none;
        border-radius: 0 4px 4px 0;

        &-title {
          padding: 0 24px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .title-pane {
            width: 5px;
            height: 14px;
            background: #269D7B;
          }

          .title-text {
            color: #269D7B;
            font-weight: 600;
            margin-left: 8px;
            font-size: 16px;
          }
        }

        &-wrapper {
          display: flex;
          justify-content: space-between;
          padding: 20px 0;
          &-bank {
            border-left: 2px solid #F6F8FA;

          }

          &-cashier {
          }

          div {
            white-space: nowrap;
          }
        }

        li {
          height: 36px;
          padding: 0 24px;
          line-height: 36px;
          font-size: 14px;
          text-align: left;
          cursor: pointer;
          color: #666;

          &:hover {
            background-color: #deefea;
            color: #2CB18B
          }
        }
      }

      .c-double {
        width: 241px;

        &>li {
          width: 120px;
          float: left;
        }
      }

      &:hover {
        .c-child-menu {
          display: block;
        }
      }
    }

    &-bank {
      padding: 0 10px;
      position: relative;
      .c-child-menu {
        display: none;
        position: absolute;
        top: 0;
        z-index: 1999;
        left: 140px;
        width: 140px;
        padding-left: 0;
        list-style: none;
        background-color: #fff;
        border: solid 1px #20BD90;
        border-left: none;
        border-radius: 0 4px 4px 0;

        &>li {
          height: 50px;
          line-height: 50px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          color: #666;

          &:hover {
            background-color: #deefea;
            color: #2CB18B
          }
        }
      }

      .c-double {
        width: 241px;

        &>li {
          width: 120px;
          float: left;
        }
      }

      &:hover {
        .c-child-menu {
          display: block;
        }
      }
    }

    &-base {
      &-wrapper {
        padding: 10px;
        display: flex;
        align-items: center;
        border-radius: 4px;
        align-content: center;
        cursor: pointer;
        color: #269d7b;
        background: rgba(38, 157, 123, .1);

        &:hover {
          background: rgba(38, 157, 123, .2);
          &:hover {
            background-color: #deefea;
            color: #2CB18B
          }
        }
      }

      &-img {
        width: 26px;
        margin-right: 10px;
      }

      &-label {
        font-size: 16px;
        white-space: nowrap;
      }

    }

  }

  .navImg {
    margin-right: 15px;
    display: inline-block;
    width: 26px;
  }

  .menu-nav {
    list-style: none;
    margin: 0;
    padding: 10px 0;
    margin-top: 20px;

    &>li {
      padding: 0 10px;
      .menu-nav-item {
        padding: 0 10px;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: left;
        height: 50px;
        line-height: 50px;
        color: #999;
        font-size: 16px;
        border-radius: 4px;
        &.active {
          background-color: #deefea;
          border-right: solid 3px #20BD90;
          font-weight: 600;
          color: #269D7B
        }
        &:hover {
          background-color: #deefea;
          color: #2CB18B
        }
      }
      &:hover ul.child-menu {
        display: block
      }
      ul.child-menu {
        display: none;
        position: absolute;
        z-index: 1999;
        left: 130px;
        padding-left: 0;
        list-style: none;
        background-color: #fff;
        box-shadow: 2px 2px 8px 0 #9e9e9e66;
        border-left: none;
        border-radius: 0 4px 4px 0;
        padding: 12px 0;
        color: #666 !important;
        &>li {
          height: 36px;
          line-height: 36px;
          font-weight: normal !important;
          font-size: 14px;
          text-align: left;
          padding: 0 24px;
          box-sizing: border-box;
          width: 150px;
          &:hover {
            background-color: #deefea;
            color: #2CB18B
          }
        }
      }

      ul.child-menu.double {
        width: 301px;
        &>li {
          width: 150px;
          float: left;
          &:nth-child(2n-1) {
            border-right: 2px solid #F6F8FA;
          }
        }
      }
    }

    &>li {
      .child-menu {
        top: 0
      }
    }

    &>li:last-child {
      .child-menu {
        bottom: 0;
        top: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/MenuNav.vue